/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Error_TimeoutInputs */

const en_backend_session_error_timeout = /** @type {(inputs: Backend_Session_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The session did not respond within the timeout. Please retry, or contact support if the issue persists.`)
};

const fr_backend_session_error_timeout = /** @type {(inputs: Backend_Session_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La session ne répond pas dans le délai imparti. Réessayez ou contactez le support si le problème persiste.`)
};

const ms_sg2_backend_session_error_timeout = /** @type {(inputs: Backend_Session_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi tidak respons dalam masa yang ditetapkan. Sila cuba semula, atau hubungi sokongan jika isu berterusan.`)
};

/**
* | output |
* | --- |
* | "The session did not respond within the timeout. Please retry, or contact support if the issue persists." |
*
* @param {Backend_Session_Error_TimeoutInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_timeout = /** @type {((inputs?: Backend_Session_Error_TimeoutInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_TimeoutInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_timeout(inputs)
	if (locale === "fr") return fr_backend_session_error_timeout(inputs)
	return ms_sg2_backend_session_error_timeout(inputs)
});